import React, {useEffect, useState} from "react";
import {Account} from "../../types";
import StatusAccountCard from "./StatusAccountCard";

export default function RenderRate({rate, showPhotos = false}: {rate: Array<Account>|null, showPhotos?: boolean}) {
    const [readyCnt, setReadyCnt] = useState(0);

    useEffect(() => {
        setReadyCnt(0);
    }, [rate?.length, showPhotos]);

    if (!rate || !showPhotos) return null;

    const readyToRenderCards = readyCnt === rate.length;

    return (
        <>
            <h2 className={"mt-2 mb-1 text-center"} style={{color: "silver"}}>Екипът</h2>

            {
                rate.map(
                    (item, idx) =>
                        <img
                            key={`preview-${item.id ?? idx}`}
                            style={{display: 'none'}}
                            src={'http://erp.taifun-bg.com/api/user/' + item.id + '/photo'}
                            onLoad={() => setReadyCnt(prev => prev + 1)}
                            alt={item.name}
                        />
                )
            }

            {
                readyToRenderCards &&
                rate.map(
                    (u, i) =>
                        <StatusAccountCard user={u} position={i + 1} key={u.id ?? i}/>
                )
            }
        </>
    )
}
